import { useRouter } from "next/router";

export function useQueryParams() {
  const router = useRouter();
  return router.query;
}
